<!--
 * @Author: Lemon C
 * @Date: 2024-08-06 10:44:37
 * @LastEditTime: 2025-01-13 17:24:45
-->
<template>
    <div class="sup-next-product">
        <div class="jump-left-box" v-if="next_jump_left_obj && next_jump_left_obj.id.length" @click="next_jump_active(0)">
            <el-icon><ArrowLeft /></el-icon>
            <span>{{ `上一篇：` + next_jump_left_obj.coverTitle }}</span>
        </div>
        <div class="jump-right-box" v-if="next_jump_right_obj && next_jump_right_obj.id.length" @click="next_jump_active(1)">
            <span>{{ `下一篇：` + next_jump_right_obj.coverTitle }}</span>
            <el-icon><ArrowRight /></el-icon>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { nextTick, ref, watch } from 'vue';

const props = defineProps({
    comp_product_list: {
        type: Array,
        default: () => [],
    },
    comp_curr_product_id: String, //当前产品id
    comp_next_jump_callback: Function,
});

const next_jump_left_obj = ref(null);
const next_jump_right_obj = ref(null);

watch([() => props.comp_curr_product_id, () => props.comp_product_list], () => {
    setTimeout(() => {
        handleNextData();
    }, 100);// 加延迟，防止变化太快
});

// MARK Click 跳转
const next_jump_active = (type) => {
    if (type == 1) {
        props.comp_next_jump_callback(next_jump_right_obj.value.id);
    } else {
        props.comp_next_jump_callback(next_jump_left_obj.value.id);
    }
};

// MARK Handle 处理前后文章数据
const handleNextData = () => {
    let find_obj = props.comp_product_list.find((obj) => obj.id == props.comp_curr_product_id);
    let find_index = props.comp_product_list.findIndex((item) => item.id === props.comp_curr_product_id);
    if (!find_obj) return;
    if (find_index === 0) {
        next_jump_left_obj.value = null;
        next_jump_right_obj.value = props.comp_product_list[find_index + 1] ? props.comp_product_list[find_index + 1] : null;
    } else if (find_index === props.comp_product_list.length - 1) {
        next_jump_left_obj.value = props.comp_product_list[find_index - 1] ? props.comp_product_list[find_index - 1] : null;
        next_jump_right_obj.value = null;
    } else {
        next_jump_left_obj.value = props.comp_product_list[find_index - 1] ? props.comp_product_list[find_index - 1] : null;
        next_jump_right_obj.value = props.comp_product_list[find_index + 1] ? props.comp_product_list[find_index + 1] : null;
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-next-product {
    position: relative;
    display: flex;
    flex-shrink: 0;
    height: calc(35px + 32px);

    .jump-left-box {
        left: 0;
    }

    .jump-right-box {
        right: 0;
        justify-content: flex-end;
    }

    .jump-right-box,
    .jump-left-box {
        position: absolute;
        top: 0px;
        height: 35px;
        width: 50%;
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
            max-width: 80%;
            color: var(--color-main-text-secondary);
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0 10px;
        }
        i {
            color: var(--color-main-text-primary);
            font-size: 20px;
        }
    }
}
</style>
